export default __webpack_public_path__ + "static/media/cp-resource@3x.f6b8979b.png";